import * as React from "react";
import {match, Switch} from "react-router";
import AdminRoute from "./route/AdminRoute";
import LeadStatusesList from "../components/admin/leadStatuses/LeadStatusesList";
import LeadStatusConfig from "../components/admin/leadStatuses/LeadStatusConfig";

interface RouteProps {
	/**
	 * Route match url.
	 */
	match: match<any>;
}

/**
 *  Lead statuses router view.
 */
export default class LeadStatusesRouter extends React.PureComponent <RouteProps, {}> {

	render() {
		return (
			<Switch>
				<AdminRoute exact path={this.props.match.url} component={LeadStatusesList}/>
				<AdminRoute exact path={this.props.match.url + "/config"} component={LeadStatusConfig}/>
			</Switch>
		)
	}

}